import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { terms as termsApi } from '../lib/api';
import { ScrollText, Loader2 } from 'lucide-react';

/**
 * Read-only viewer for the BharatCart Platform Terms.
 * Used as a "Read full terms" link from Checkout and AuthModal.
 */
export default function PlatformTermsModal({ open, onOpenChange }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    termsApi.platform().then(d => { if (!cancelled) setData(d); }).catch(() => {});
    return () => { cancelled = true; };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="platform-terms-modal" className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <ScrollText className="w-5 h-5 text-[#D35400]"/>BharatCart — Platform Terms of Use
          </DialogTitle>
        </DialogHeader>
        {!data ? (
          <div className="py-10 text-center text-sm text-ink/60 flex items-center justify-center gap-2">
            <Loader2 className="w-4 h-4 animate-spin"/>Loading terms…
          </div>
        ) : (
          <>
            <div className="text-[11px] uppercase tracking-[0.18em] text-ink/50 font-semibold">
              Version: <span className="text-ink">{data.version}</span>
              {data.accepted_version === data.version && (
                <span data-testid="platform-terms-accepted-badge" className="ml-2 text-[#1B5E20] normal-case tracking-normal">✓ You have accepted this version</span>
              )}
            </div>
            <div
              data-testid="platform-terms-body"
              className="mt-2 max-h-[60vh] overflow-y-auto rounded-md border border-border bg-[#FBF8F1] p-4 text-[13px] leading-relaxed text-ink whitespace-pre-wrap font-mono"
            >
              {data.text}
            </div>
            <div className="mt-3 flex justify-end">
              <button
                data-testid="platform-terms-close-btn"
                onClick={() => onOpenChange(false)}
                className="rounded-full border border-border px-4 py-2 text-sm font-semibold hover:bg-muted"
              >Close</button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
